module.exports = __webpack_public_path__ + "fonts/SourceSansPro-BlackItalic.9912ce73.ttf";